export default __webpack_public_path__ + "static/media/queries-1.ee2f1a73.png";